import React from 'react'
import { navigate } from 'gatsby'
import clsx from 'clsx'
import { Button } from '@/components/atoms/Button/Button'
import { getUrl } from '@/helpers/getUrl'
import { removeFoldersFromUrl } from '@/helpers/removeFoldersFromUrl'
import { withTrailingSlash } from '@/helpers/withTrailingSlash'
import { Paragraph } from '@/components/atoms/MarkdownElements/MarkdownElements'
import * as styles from './DiscoveryBox.module.css'

export function DiscoveryBox({ title, description, url, background_image, button }: DiscoveryBox) {
  const link = url.url || removeFoldersFromUrl(url.cached_url)
  const buttonUrl = !!button?.length && getUrl(button[0].url)

  return button && button.length > 0 ? (
    <li
      className={clsx(
        styles.discoveryBox,
        'flex flex-col items-center my-80 py-24 px-20 bg-white rounded-md border-1 border-grey-100',
        'netbook:border-none netbook:shadow-dropdown netbook:rounded-3xl netbook:items-start',
        'netbook:py-80 netbook:px-32 tablet:mt-0 tablet:mb-32 laptop:pt-128 hover:shadow-form'
      )}
      style={{ background: `url(${background_image?.image})` }}
    >
      {title && <h2 className="font-poppins text-bodyL font-bold mb-16 netbook:text-white">{title}</h2>}
      {description && (
        <Paragraph className="font-mulish text-bodyL text-center mb-16 netbook:text-left netbook:text-white">
          {description}
        </Paragraph>
      )}
      <Button
        {...button[0]}
        className="w-full border-none mt-auto font-mulish"
        onClick={() => navigate(withTrailingSlash(buttonUrl || ''))}
      >
        {button[0].text}
      </Button>
    </li>
  ) : (
    <li
      className={clsx(
        styles.discoveryBox,
        'flex flex-col w-full mb-16 shadow-dropdown rounded-md',
        'netbook:rounded-3xl netbook:py-80 netbook:px-32 netbook:mb-32 laptop:pt-128 hover:shadow-form'
      )}
      style={{ background: `url(${background_image?.image})` }}
    >
      <a href={withTrailingSlash(link)}>
        <div className="relative netbook:text-white pl-48 py-12 pr-16 netbook:p-0 text-text-dark-900">
          <div className="block absolute top-0 left-0 w-32 h-full rounded-md netbook:hidden overflow-hidden">
            <img src={background_image?.image} alt={title} className="h-full w-auto object-cover object-left-top" />
          </div>
          {title && <h2 className="font-poppins font-bold text-bodyL mb-16">{title}</h2>}
          {description && <Paragraph className="font-mulish text-bodyL">{description}</Paragraph>}
        </div>
      </a>
    </li>
  )
}
